import { render } from "./ManageHighlightPage.vue?vue&type=template&id=f6d352ce"
import script from "./ManageHighlightPage.vue?vue&type=script&lang=ts"
export * from "./ManageHighlightPage.vue?vue&type=script&lang=ts"

import "./ManageHighlightPage.vue?vue&type=style&index=0&id=f6d352ce&lang=scss"
script.render = render

export default script